var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnassignedContacts(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8326_2038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12Z",
    fill: "url(#paint0_linear_8326_2038)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 17C11.3167 17 10.6708 16.8688 10.0625 16.6062C9.45417 16.3438 8.92292 15.9854 8.46875 15.5312C8.01458 15.0771 7.65625 14.5458 7.39375 13.9375C7.13125 13.3292 7 12.6833 7 12C7 11.3083 7.13125 10.6604 7.39375 10.0563C7.65625 9.45208 8.01458 8.92292 8.46875 8.46875C8.92292 8.01458 9.45417 7.65625 10.0625 7.39375C10.6708 7.13125 11.3167 7 12 7C12.6917 7 13.3396 7.13125 13.9437 7.39375C14.5479 7.65625 15.0771 8.01458 15.5312 8.46875C15.9854 8.92292 16.3438 9.45208 16.6062 10.0563C16.8688 10.6604 17 11.3083 17 12C17 12.6833 16.8688 13.3292 16.6062 13.9375C16.3438 14.5458 15.9854 15.0771 15.5312 15.5312C15.0771 15.9854 14.5479 16.3438 13.9437 16.6062C13.3396 16.8688 12.6917 17 12 17ZM12 15C12.8333 15 13.5417 14.7083 14.125 14.125C14.7083 13.5417 15 12.8333 15 12C15 11.1667 14.7083 10.4583 14.125 9.875C13.5417 9.29167 12.8333 9 12 9C11.1667 9 10.4583 9.29167 9.875 9.875C9.29167 10.4583 9 11.1667 9 12C9 12.8333 9.29167 13.5417 9.875 14.125C10.4583 14.7083 11.1667 15 12 15Z",
    fill: "#F7F7F7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8326_2038",
    x1: 12,
    y1: 0,
    x2: 12,
    y2: 24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3E33DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A59FFF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8326_2038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassignedContacts);
export default __webpack_public_path__ + "static/media/unassigned_contacts.a179a475fef7d24aaeb68a664fa4ea1a.svg";
export { ForwardRef as ReactComponent };